import { BounceLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';

// Show errors in formik form
export const errorHelper = (formik, values) => ({
    error: formik.errors[values] && formik.touched[values] ? true : false,
    helperText: formik.errors[values] && formik.touched[values] ? formik.errors[values] : null
})

// React-spinners Loader
export const Loader = () => (
    <div>
        <BounceLoader color="#36D7B7" loading={true} />
    </div>
)

// React-toastify Toast
export const showToast = (type, msg) => {
    switch(type) {
        case 'SUCCESS':
            toast.success(msg, {
                position: toast.POSITION.BOTTOM_LEFT
            })
        break;
        case 'ERROR':
            toast.error(msg, {
                position: toast.POSITION.BOTTOM_LEFT
            })
        break;
        case 'WARNING':
            toast.warning(msg, {
                position: toast.POSITION.BOTTOM_LEFT
            })
        break;
        default:
            return false;
    }
}

// Format date from ISO standard
export const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month are indexed from 0
    const year = date.getFullYear();
    return `${day}.${month}.${year}`; 
};

// Current year
export const currentYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear;
}


// Cookies from the browser
export const getTokenCookie = () => cookie.load('x-access-token');
export const removeTokenCookie = () => { cookie.remove('x-access-token', {path:'/'})};

// Active tenant persistence
export const getActiveTenantId = () => localStorage.getItem('x-tenant-id');
export const setActiveTenantId = (id) => localStorage.setItem('x-tenant-id', id);
export const removeActiveTenantId = () => localStorage.removeItem('x-tenant-id');

export const getAuthHeader = () => {
    const headers = {};
    const tenantId = getActiveTenantId();
    if (tenantId) headers['x-tenant-id'] = tenantId;
    return { headers };
}

// Format number to 3 decimal
export const formatNumber = (num) => {
    if(num % 1 !== 0) {
        return num.toFixed(3);
    } else {
        return num.toString();
    }
}

// Truncate text
export const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

const { FREE_PLAN } = require('../config/plans');

// Returns true when tenant can perform actions
// Demo trialing: allowed within plan limits
// Demo canceled (expired): blocked — same buttons disabled, red PaymentAlert shown
export const isSubscriptionActive = (subscriptionStatus, plan) => {
    if (plan === FREE_PLAN) return subscriptionStatus === 'trialing';
    return subscriptionStatus === 'active' || subscriptionStatus === 'past_due';
};

// Returns true when payment CTA should be shown
export const shouldShowPaymentAlert = (subscriptionStatus, plan) => {
    if (plan === FREE_PLAN) return true; // demo always shows upgrade CTA
    return subscriptionStatus === 'canceled' || subscriptionStatus === 'past_due';
};

